import assign from 'lodash/assign';
import constants from '../constants';

const initState = () => ({ topRentalMarkets: [] });

const topMarkets = (state = initState(), action = {}) => {
  const { type, payload } = action;

  if (type === constants.SET_TOP_MARKETS) {
    return assign({}, state, payload);
  }
  return state;
};

export default topMarkets;
